import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const BreathingHabitsChecklist = ({selectedFormId,data,shouldPrint,selectedClientDetails}) => {
  const { t } = useTranslation();
const initialPersonalInfo = {
  name: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
  date: "",
  email: "",
  tel: "",
  sex: "",
  age: "",
  sigOther: "",
  children: "",
  issue: "",
  dysfunctionalBreathingDescription: "",
  generalComments: "",
};
  const [personalInfo, setPersonalInfo] = useState(data?data?.personalInfo:initialPersonalInfo);

  const symptoms = [
    { id: 1, text: "Chest tightness, pressure, or pain", hasRedDot: true },
    { id: 2, text: "Intentional breathing, purposeful regulation" },
    { id: 3, text: "Blurred or hazy vision" },
    { id: 4, text: "Dizziness, light-headedness, fainting", hasRedDot: true },
    { id: 5, text: "Disconnected, things seem distant" },
    { id: 6, text: "Shortness of breath, difficulty breathing", hasRedDot: true },
    { id: 7, text: "Tingling or numbness, e.g., fingers, lips", hasRedDot: true },
    { id: 8, text: "Disoriented, confused" },
    { id: 9, text: "Unable to breathe deeply", hasRedDot: true },
    { id: 10, text: "Muscle pain, stiffness, e.g., hands, jaw, back" },
    { id: 11, text: "Not exhaling completely, aborting the exhale", hasRedDot: true },
    { id: 12, text: "Deep breathing, like during talking", hasRedDot: true },
    { id: 13, text: "Fast or irregular heartbeat" },
    { id: 14, text: "Chest breathing, effortful breathing", hasRedDot: true },
    { id: 15, text: "Breath holding, irregular breathing" },
    { id: 16, text: "Poor concentration, focus, memory" },
    { id: 17, text: "Rapid breathing, panicky breathing", hasRedDot: true },
    { id: 18, text: "Fatigue easily" },
    { id: 19, text: "Worried about my breathing", hasRedDot: true },
    { id: 20, text: "Mouth breathing", hasRedDot: true },
    { id: 21, text: "Hard to swallow, nauseous" },
    { id: 22, text: "Can't seem to get enough oxygen", hasRedDot: true },
    { id: 23, text: "Hyper-aroused, can't calm down, anxious" },
    { id: 24, text: "Unexpected mood changes (e.g., anger)" },
  ];

  const situations = [
    { id: 1, text: "working (employment)" },
    { id: 2, text: "resting (between tasks)" },
    { id: 3, text: "performing (e.g., test taking)" },
    { id: 4, text: "talking, eating, singing" },
    { id: 5, text: "feeling anxious or worried" },
    { id: 6, text: "feeling tired or stressed" },
    { id: 7, text: "interacting in groups" },
    { id: 8, text: "physical challenges, exercising" },
    { id: 9, text: "being confronted by others" },
    { id: 10, text: "traveling, unfamiliar places" },
    { id: 11, text: "socializing, meeting people" },
    { id: 12, text: "speaking in public, in groups" },
    { id: 13, text: "feeling angry or upset" },
    { id: 14, text: "intimacy, expressing feelings" },
    { id: 15, text: "physical discomfort, pain" },
    { id: 16, text: "meeting authority figures" },
    { id: 17, text: "going to sleep, while asleep" },
    { id: 18, text: "being accountable, in-charge" },
    { id: 19, text: "learning new tasks, new info" },
    { id: 20, text: "feeling unsure of self" },
    { id: 21, text: "allergens, weather, foods" },
  ];
console.log(data);

  // Initialize symptomResponses based on symptoms array
const initialSymptomResponses = symptoms.reduce((acc, symptom) => {
  acc[symptom.id] = { yesNo: null, frequency: null, situations: "", comment: "" };
  return acc;
}, {});
  // State for symptom responses
const [symptomResponses, setSymptomResponses] = useState(() => {
  if (data?.symptomResponses) {
    // convert keys to numbers and merge with defaults
    const formatted = Object.entries(data.symptomResponses).reduce((acc, [key, val]) => {
      const id = Number(key);
      acc[id] = {
        yesNo: val?.yesNo ?? null,
        frequency: val?.frequency ?? null,
        situations: val?.situations ?? "",
        comment: val?.comment ?? "",
      };
      return acc;
    }, {});
    return { ...initialSymptomResponses, ...formatted };
  }
  return initialSymptomResponses;
});


  // Handlers
  const handlePersonalInfoChange = (e) => {
    const { name, value } = e.target;
    setPersonalInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleYesNoChange = (symptomId, value) => {
    setSymptomResponses((prev) => ({
      ...prev,
      [symptomId]: { ...prev[symptomId], yesNo: value },
    }));
  };

  const handleFrequencyChange = (symptomId, value) => {
    setSymptomResponses((prev) => ({
      ...prev,
      [symptomId]: { ...prev[symptomId], frequency: value },
    }));
  };

  const handleSituationsChange = (symptomId, value) => {
    setSymptomResponses((prev) => ({
      ...prev,
      [symptomId]: { ...prev[symptomId], situations: value },
    }));
  };

  const handleCommentChange = (symptomId, value) => {
    setSymptomResponses((prev) => ({
      ...prev,
      [symptomId]: { ...prev[symptomId], comment: value },
    }));
  };


    const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);


const handleSubmit = () => {
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);

  // Prepare form data
  const formData = {
    personalInfo,
    symptomResponses,
  };

  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
  };

  // console.log("📤 Sending form payload:", payload);

  fetch(API_URL + "/forms/client/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
         setPersonalInfo(initialPersonalInfo);
        setSymptomResponses(initialSymptomResponses);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      // Stop loader in all cases
      setLoading(false);
    });
};


  return (
    <div>
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: 16, backgroundColor: "white", border: !data && "1px solid #ccc", fontFamily: "Arial, sans-serif", marginTop: 16 }}>
      <div style={{ textAlign: "center", marginBottom: "16px" }}>
        <h1 style={{ fontSize: "20px", fontWeight: "bold" }}>
          INTERVIEW CHECKLIST
        </h1>
        <p
          style={{
            color: "#7030a0",
            fontStyle: "italic",
            fontSize: "17px",
            marginTop: "-12px",
            fontWeight: "bold",
          }}
        >
          For learning about your breathing habits
        </p>
      </div>

      <p style={{ marginBottom: "16px", fontSize: "14px" }}>
        This checklist has been designed to serve as a "guideline" for assisting
        you in exploring whether or not your breathing habits are consistent
        with optimal respiration, and if not, how they may be affecting you at
        specific times and places.
      </p>
        {/* Personal Info Section */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
          {[
            { label: "Name", name: "name", width: 280 },
            { label: "Date", name: "date", width: 170 },
            { label: "Email", name: "email", width: 290 },
            { label: "Tel", name: "tel", width: 160 },
            { label: "Sex", name: "sex", width: 40 },
            { label: "Age", name: "age", width: 40 },
            { label: "Sig Other", name: "sigOther", width: 80 },
            { label: "Children", name: "children", width: 40 },
            { label: "Issue", name: "issue", width: 230 },
          ].map((field) => (
            <div key={field.name} style={{ display: "flex", alignItems: "flex-end", gap: 10 }}>
              <label>{field.label}:</label>
              <input
                type="text"
                name={field.name}
                value={personalInfo[field.name]}
                onChange={handlePersonalInfoChange}
                disabled={field.name==="name" && Boolean(selectedClientDetails)}
                style={{
                  height: 30,
                  width: field.width,
                  backgroundColor: "#f1f4ff",
                  borderBottom: "2px solid #444",
                  borderTop: "none",
                  borderLeft: "none",
                  borderRight: "none",
                  outline: "none",
                }}
              />
            </div>
          ))}
        </div>

        {/* Dysfunctional Breathing Description */}
        <div style={{ marginBottom: 24 }}>
          <p style={{ fontWeight: "bold", marginBottom: 4 }}>
            Do you think you might have a dysfunctional breathing habit? If so, what difficulties are you having that might be related to breathing?
          </p>
          <textarea
            name="dysfunctionalBreathingDescription"
            value={personalInfo.dysfunctionalBreathingDescription}
            onChange={handlePersonalInfoChange}
            style={{
              width: "100%",
              height: 60,
              backgroundColor: "#f1f4ff",
              borderBottom: "2px solid #444",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
            }}
          />
        </div>
  <div style={{ marginBottom: "16px" }}>
        <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
          Do you ever experience any of the 24 symptoms listed below?
        </p>
        <p style={{ fontSize: "14px", marginTop: "4px" }}>
          Check the <span style={{ fontWeight: "bold" }}>Y column</span> for
          "YES," OR the <span style={{ fontWeight: "bold" }}>N column</span> for
          "NO," after each symptom listed. If you checked YES, indicate{" "}
          <span style={{ fontStyle: "italic", color: "#7030a0" }}>
            how frequently you experience the symptom
          </span>{" "}
          by checking a number 1 through 7, where 1 is rarely and 7 is daily.
          Then enter in the{" "}
          <span style={{ fontStyle: "italic", color: "#7030a0" }}>
            situations in which you experience a symptom
          </span>
          , in the "situation column," by entering a number that corresponds to
          one of the 21 situations listed at the bottom of the page. For
          example, you might check column #6 for "dizziness" and then enter in
          situations #14 (expressing feelings) and #19 (learning new tasks). If
          the situation is not shown on the list, write it into the "comment"
          column. Focus on when, where, and with whom these symptoms may occur.
        </p>
      </div>

      <div
        style={{ marginBottom: "8px", fontSize: "14px", textAlign: "center" }}
      >
        <p style={{ margin: "0" }}>
          How often? 1 = rarely ................... 7 = every day
        </p>
      </div>
        {/* Symptoms Table */}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f2f2f2" }}>
                <th style={{ border: "1px solid #999", padding: 4, textAlign: "left" }}>Do you experience the following? If so, how often?</th>
                <th style={{ border: "1px solid #999", padding: 4, width: 30, textAlign: "center" }}>N</th>
                <th style={{ border: "1px solid #999", padding: 4, width: 30, textAlign: "center" }}>Y</th>
                {[1, 2, 3, 4, 5, 6, 7].map((num) => (
                  <th key={num} style={{ border: "1px solid #999", padding: 4, width: 25, textAlign: "center" }}>{num}</th>
                ))}
                <th style={{ border: "1px solid #999", padding: 4, textAlign: "center" }}>Situations</th>
                <th style={{ border: "1px solid #999", padding: 4, textAlign: "center" }}>Comment</th>
              </tr>
            </thead>
            <tbody>
          {symptoms.map((symptom, index) => {
  const response = symptomResponses[symptom.id] || {};
  {/* console.log("Rendering symptom:", symptom.id, response); */}
  return (
    <tr key={symptom.id}>
      {/* Symptom Name */}
      <td
        style={{
          border: "1px solid #999",
          padding: "4px",
          textAlign: "left",
          backgroundColor: "#f4ebff",
        }}
      >
        {symptom.text}{" "}
        {symptom.hasRedDot && <span style={{ color: "red" }}>●</span>}
      </td>

      {/* Yes / No Checkboxes */}
      {[false, true].map((value) => (
        <td
          key={value}
          style={{
            border: "1px solid #999",
            padding: "4px",
            textAlign: "center",
            backgroundColor: index % 2 === 0 ? "#eae8ff" : "#f1f4ff",
          }}
        >
          <input
            type="checkbox"
            checked={response.yesNo === value}
            style={{
              width: "16px",
              height: "16px",
              appearance: "none",
              border: "none",
              cursor: "pointer",
              borderRadius: "50%",
              marginRight:"0",
              backgroundColor: response.yesNo === value ? "#007bff" : "transparent",
            }}
            onChange={() => handleYesNoChange(symptom.id, value)}
          />
           {shouldPrint && data && response.yesNo === value && (
            <span style={{ color: "#007bff", fontWeight: "bold", fontSize: "20px" }}>●</span>
          )}
        </td>
      ))}

      {/* Frequency 1-7 */}
      {[1, 2, 3, 4, 5, 6, 7].map((num) => (
        <td
          key={num}
          style={{
            border: "1px solid #999",
            padding: "4px",
            textAlign: "center",
            backgroundColor: index % 2 === 0 ? "#eae8ff" : "#f1f4ff",
          }}
        >
          <input
            type="checkbox"
            checked={response.frequency === num}
            style={{
              width: "16px",
              marginRight:"0",
              height: "16px",
              appearance: "none",
              border: "none",
              cursor: "pointer",
              borderRadius: "50%",
              backgroundColor: response.frequency === num ? "#007bff" : "transparent",
            }}
            onChange={() => handleFrequencyChange(symptom.id, num)}
          />
           {shouldPrint && data && response.frequency === num && (
      <span
        style={{
          color: "#007bff",
          fontWeight: "bold",
          fontSize: "20px",
        }}
      >
        ●
      </span>
    )}
        </td>
      ))}

      {/* Situations Input */}
      <td
        style={{
          border: "1px solid #999",
          padding: "4px",
          backgroundColor: index % 2 === 0 ? "#eae8ff" : "#f1f4ff",
        }}
      >
        <input
          type="text"
          value={response.situations || ""}
          onChange={(e) => handleSituationsChange(symptom.id, e.target.value)}
          style={{
            width: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
          }}
        />
      </td>

      {/* Comment Input */}
      <td
        style={{
          border: "1px solid #999",
          padding: "4px",
          backgroundColor: index % 2 === 0 ? "#eae8ff" : "#f1f4ff",
        }}
      >
        <input
          type="text"
          value={response.comment || ""}
          onChange={(e) => handleCommentChange(symptom.id, e.target.value)}
          style={{
            width: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
          }}
        />
      </td>
    </tr>
  );
})}

            </tbody>
          </table>
        </div>

        {/* Situations list */}
          <div style={{ marginTop: "24px", marginBottom: "16px" }}>
        <strong>*SITUATIONS:</strong> circumstances under which you experience
        the above symptoms
      </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 8, fontSize: 14, marginBottom: 24 }}>
          {situations.map((situation) => (
            <div key={situation.id} style={{ display: "flex" }}>
              <span style={{ marginRight: 4 }}>({situation.id})</span>
              <span>{situation.text}</span>
            </div>
          ))}
        </div>

        {/* General comments */}
        <div style={{ display: "flex", alignItems: "flex-end", gap: 20, marginBottom: 16 }}>
          <label style={{ fontSize: 12, fontWeight: "bold" }}>General Comments:</label>
          <input
            type="text"
            name="generalComments"
            value={personalInfo.generalComments}
            onChange={handlePersonalInfoChange}
            style={{
              height: 30,
              width: "80%",
              backgroundColor: "#f1f4ff",
              borderBottom: "2px solid #444",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              outline: "none",
            }}
          />
        </div>

     {!data &&   <div className="client-submit-btn">
          <button type="button" onClick={handleSubmit}>{loading?t("Submitting..."):t("Submit")}</button>
        </div>}
      </div>
         <Modal
                    isOpen={successModal}
                    toggle={successToggleModal}
                    className="connect-box"
                    centered={true}
                  >
                    <ModalHeader toggle={successToggleModal}>
                      <span className="ml-1 roititle font-weight-bold">
                        Successfull
                      </span>
                    </ModalHeader>
                    <ModalBody>
                      <div className="modal-p">
                        <p>Client form has been submitted successfully.</p>
                      </div>
                    </ModalBody>
                  </Modal>
    </div>
  );
};

export default BreathingHabitsChecklist;
